export default __webpack_public_path__ + "static/media/google-reviews.58fbe7cf.png";